import { Component, OnInit } from '@angular/core';
import { NgForm} from '@angular/forms';
import { UserService } from '../shared/services/user.service';
import { Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { GlobalNotification} from "../shared/constants/global-notification";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
formModel ={
  UserName : "",
  Password : ""
}
  constructor(
    private service:UserService,
    private router : Router,
   /* private toastr : ToastrService,
    private snackBar: MatSnackBar*/
    private gnotify : GlobalNotification
    ) { }

  ngOnInit() {
    if(localStorage.getItem("token") != null)
    {
      this.router.navigateByUrl('');
    }

  }

  onSubmit(form:NgForm){
    this.service.login(form.value).subscribe(
      (res : any) => {
        localStorage.setItem("token", res.token);
        this.router.navigateByUrl('/dashboard');
      },
      err => {
        if(err.status == 400)
        {
         //// this.toastr.error("Incorrect username or password", "Authentication failed");
          this.gnotify.showSnackBar('Authentication failed', 'Incorrect username or password', "error");
        }
        else{
          console.log(err);
          //this.toastr.error(err.message, "Authentication failed");
          this.gnotify.showSnackBar('Authentication failed', err.message, "error");
        }
      }
    );
  }

  onRequestReset()
  {
    if(!this.formModel.UserName || this.formModel.UserName.length == 0)
    {
     //// this.toastr.warning("Pleaes input your Username", "Invalid request");
     this.gnotify.showSnackBar('Invalid request', "Pleaes input your Username", "warning");
     return;
    }
    this.service.requestResetPassword(this.formModel.UserName).subscribe(
      res =>{
         ////this.toastr.success("Pleaes check your email!", "Password reset e-mail is sent!");
         this.gnotify.showSnackBar("Password reset", "Reset e-mail is sent! Pleaes check your email!", "success");
      },
      err=>{
       //// this.toastr.error("Fail to send a password reset e-mail", "Request failed");
       this.gnotify.showSnackBar("Request failed", "Fail to send a password reset e-mail", "error");
      }
    );
  }
}
